module.exports = __webpack_public_path__ + "img/PORTO-5.0ML.19b366cd.png";